/* global axios */
import ApiClient from './ApiClient';

export const buildRequestParams = (page, sortAttr, label, search, organization) => {
  let params = `include_contact_inboxes=false&page=${page}&sort=${sortAttr}`;
  if (search) {
    params = `${params}&q=${search}`;
  }
  if (label) {
    params = `${params}&labels[]=${label}`;
  }
  if (organization) {
    params = `${params}&organization=${organization}`;
  }
  return params;
};

class RequestAPI extends ApiClient {
  constructor() {
    super('requests', { accountScoped: true });
  }

  get(page, sortAttr = 'name', label = '', organization = '') {
    let requestURL = `${this.url}?${buildRequestParams(
      page,
      sortAttr,
      label,
      '',
      organization
    )}`;
    return axios.get(requestURL);
  }

  search(search = '', page = 1, sortAttr = 'name', label = '', organization = '') {
    let requestURL = `${this.url}/search?${buildRequestParams(
      page,
      sortAttr,
      label,
      search,
      organization
    )}`;
    return axios.get(requestURL);
  }

  // eslint-disable-next-line default-param-last
  filter(page = 1, sortAttr = 'name', queryPayload) {
    let requestURL = `${this.url}/filter?${buildRequestParams(page, sortAttr)}`;
    return axios.post(requestURL, queryPayload);
  }
}

export default new RequestAPI();
